import { Search } from "lucide-react";
import { Pill } from "@/components/PdPill";
import { istDate } from "@/components/DispatchDatePicker";

export const RANGES = [
  { id: "today", label: "Today" },
  { id: "yesterday", label: "Yesterday" },
  { id: "7d", label: "7 Days" },
  { id: "all", label: "All" },
  { id: "custom", label: "Custom" },
];

export const rangeDates = (range, from, to) => {
  if (range === "today") return [istDate(0), istDate(0)];
  if (range === "yesterday") return [istDate(1), istDate(1)];
  if (range === "7d") return [istDate(6), istDate(0)];
  if (range === "custom") return [from, to];
  return ["", ""];
};

const date = "h-8 px-2 rounded-lg border border-[#E0DFD6] text-xs bg-white";

export const CodesFilters = ({ f, set }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid="sms-codes-filters">
    {RANGES.map((r) => (
      <Pill key={r.id} on={f.range === r.id} onClick={() => set({ range: r.id })} testid={`sms-range-${r.id}`}>{r.label}</Pill>
    ))}
    {f.range === "custom" && (
      <>
        <input type="date" value={f.from} onChange={(e) => set({ from: e.target.value })} className={date} data-testid="sms-from-date" />
        <input type="date" value={f.to} onChange={(e) => set({ to: e.target.value })} className={date} data-testid="sms-to-date" />
      </>
    )}
    <select value={f.status} onChange={(e) => set({ status: e.target.value })} className="h-8 px-2 rounded-lg border border-[#E0DFD6] text-xs bg-white" data-testid="sms-status-filter">
      <option value="all">All</option>
      <option value="new">New only</option>
      <option value="copied">Copied only</option>
    </select>
    <label className="relative w-full sm:w-auto sm:ml-auto">
      <Search className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-[#9A9A90]" />
      <input value={f.q} onChange={(e) => set({ q: e.target.value })} placeholder="Mobile / code"
        className="h-8 pl-8 pr-3 w-full sm:w-48 rounded-full border border-[#E0DFD6] text-xs bg-white focus:outline-none focus:ring-2 focus:ring-[#385C4B]/30" data-testid="sms-search" />
    </label>
  </div>
);
